/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loading } from "./AllReports";
import { calculateAge } from "./PatientsTable";
import { useHistory } from "react-router-dom";

const PatientsTable = ({ data, initialLoad, sortingFunction }) => {
  const [lastNameOrder, setLastNameOrder] = useState(null);
  const [firstNameOrder, setFirstNameOrder] = useState(null);
  const [mnrOrder, setMnrOrder] = useState(null);

  let history = useHistory();

  const viewDetail = (id) => {
    localStorage.setItem("master-location", "/patients3/pending?return=true");
    history.push(`/patients3/${id}`);
  };

  const handleSort = (field) => {
    switch (field) {
      case "lastName":
        setFirstNameOrder(null);
        setMnrOrder(null);
        if (lastNameOrder === null) {
          setLastNameOrder(true);
          sortingFunction(["family", "id"]);
        } else if (lastNameOrder) {
          setLastNameOrder(false);
          sortingFunction(["-family", "id"]);
        } else {
          setLastNameOrder(null);
          sortingFunction(null);
        }
        break;
      case "firstName":
        setLastNameOrder(null);
        setMnrOrder(null);
        if (firstNameOrder === null) {
          setFirstNameOrder(true);
          sortingFunction(["name", "id"]);
        } else if (firstNameOrder) {
          setFirstNameOrder(false);
          sortingFunction(["-name", "id"]);
        } else {
          setFirstNameOrder(null);
          sortingFunction(null);
        }
        break;
      case "mrn":
        setLastNameOrder(null);
        setFirstNameOrder(null);
        if (mnrOrder === null) {
          setMnrOrder(true);
          sortingFunction(["patientLocation.mrn", "id"]);
        } else if (mnrOrder) {
          setMnrOrder(false);
          sortingFunction(["-patientLocation.mrn", "id"]);
        } else {
          setMnrOrder(null);
          sortingFunction(null);
        }
        break;
    }
  };

  return (
    <div className="contentTbl">
      <table className="overview" id="data-table">
        <thead>
          <tr>
            <th style={{ width: "4%" }}>Date Added</th>
            <th
              style={{ width: "15%" }}
              className={
                lastNameOrder === null ? "sortDisable" : lastNameOrder ? "headerSortUp" : "headerSortDown"
              }
            >
              <a href="#" onClick={() => handleSort("lastName")}>
                Last Name
              </a>
            </th>
            <th
              style={{ width: "15%" }}
              className={
                firstNameOrder === null ? "sortDisable" : firstNameOrder ? "headerSortUp" : "headerSortDown"
              }
            >
              <a href="#" onClick={() => handleSort("firstName")}>
                First Name
              </a>
            </th>
            <th style={{ width: "4%" }}>Age</th>
            <th style={{ width: "5%" }}>Gender</th>
            <th
              style={{ width: "4%" }}
              className={mnrOrder == null ? "sortDisable" : mnrOrder ? "headerSortUp" : "headerSortDown"}
            >
              <a href="#" onClick={() => handleSort("mrn")}>
                MRN
              </a>
            </th>
            <th style={{ width: "8%" }}>Email</th>
            <th style={{ width: "15%" }}>Following</th>
            <th style={{ width: "8%" }}>Home Phone</th>
            <th style={{ width: "8%" }}>Mobile Phone</th>
            <th style={{ width: "13%" }}>Locations</th>
            <th style={{ width: "1%" }}></th>
          </tr>
        </thead>

        {initialLoad ? (
          <Loading />
        ) : data.length > 0 ? (
          <tbody>
            {data.map(({ device, location, patient, ...item }, index) => (
              <tr key={item.id}>
                <td style={{ width: "4%" }}>{new Date(item.createdAt).toLocaleDateString()}</td>
                <td style={{ width: "15%" }}>{item?.family}</td>
                <td style={{ width: "15%" }}>{item?.name}</td>
                <td style={{ width: "4%" }}>{calculateAge(item?.dob)}</td>
                <td style={{ width: "5%" }}>{item?.gender}</td>
                <td style={{ width: "4%" }}>
                  {Array.isArray(item?.patientLocation) && item?.patientLocation?.map((it) => it?.mrn)}
                </td>
                <td style={{ width: "8%" }}>{item?.emailAddress}</td>
                <td style={{ width: "15%" }}>
                  {item.followingPhysician ? item.followingPhysician.family + "," : "-"}{" "}
                  {item.followingPhysician ? item.followingPhysician.name : " "}
                </td>
                <td style={{ width: "8%" }}>{item?.homePhone}</td>
                <td style={{ width: "8%" }}>{item?.mobilePhone}</td>
                <td style={{ width: "13%" }}>
                  {Array.isArray(item?.patientLocation) &&
                    item?.patientLocation?.map((it) => it?.location?.name).join(",")}
                </td>
                <td style={{ width: "1%" }}>
                  <div id={`view-btn-${index}`} className="show-options">
                    <a onClick={() => viewDetail(item.id)} className="btn">
                      View/Edit
                    </a>
                    {/* <Link to={`/patients3/${item?.id}`} className="btn">
                      Create IR
                    </Link> */}
                    {/* <button className="btn btnUrgent">Esign</button> */}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        ) : null}
      </table>
      {data.length === 0 && !initialLoad ? (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 300,
            fontSize: 18,
          }}
        >
          No patients
        </div>
      ) : null}
    </div>
  );
};

export default PatientsTable;
